import { StockLocationsPermissions } from './stockLocations.permissions';
import { StockLocationsRoles } from './stockLocations.roles';

export const stockLocationsMappings = {
  [StockLocationsPermissions.GET_STOCK_LOCATIONS]: [StockLocationsRoles.VIEWER],
  [StockLocationsPermissions.PERSIST_STOCK_LOCATION]: [
    StockLocationsRoles.PERSISTER,
  ],
  [StockLocationsPermissions.ARCHIVE_STOCK_LOCATION]: [
    StockLocationsRoles.ARCHIVER,
  ],
};
